export const deletePaymentToken = (tokenType: string, ID: string) => {
	return {
		url: `payment-processing-service/v1/payment-tokens?tokenType=${tokenType}&id=${ID}`,
		method: 'POST',
	};
};
